// Orifice meter vertex schema
// Flow measurement device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, MeterMaterialSchema } from '../base/common';

export const OrificeMeterVertexSchema = BaseVertexSchema.extend({
  type: z.literal('orifice_meter'),
  elevation: ValueWithUnitSchema,
  /**
   * Pressure tap configuration.
   * - 'corner': Corner taps at the orifice plate face
   * - 'dhd': D and D/2 taps (1D upstream, 0.5D downstream)
   * - 'flange': Flange taps (1 inch from plate on each side)
   */
  pressure_taps: z.enum(['corner', 'dhd', 'flange']),
  meter_diameter: ValueWithUnitSchema,
  device_material: MeterMaterialSchema.optional(),
  pipe_material: MeterMaterialSchema.optional(),
});

export type OrificeMeterVertex = z.infer<typeof OrificeMeterVertexSchema>;
